export { ModalHeader } from './MоdalHeader';
